// external modules
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSetRecoilState } from "recoil";
import actionNames from "native/action";
import { appVersionState } from "bridge/store/appVersionState";
import { setLanguage, setDeviceInfo, setFcmToken, setNotification } from "store/redux/modules/status";
import { scannerState } from "bridge/store/scannerState";
import { setAxiosAccessToken } from "@becon-team/becon-fe-lib/my-axios";
import { axiosInstance } from "libs/axiosInstance";
import { localStorageKeyToken } from "utils/(localStorage)";
import store from "store";

/**   // =================== 네이티브(AOS, IOS) -> 웹뷰 통신 정의  =================== //  */
function useOnResultAction() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const setAppVersion = useSetRecoilState(appVersionState);
  const setScannerStateInfo = useSetRecoilState(scannerState);
  window.onResultAction = (param, id, rawData) => {
    // param is language
    // rawData is {language : "ko"};
    let action = param;
    let data = rawData;
    let decodedParam = window.atob(param);
    // * IOS인 경우 데이터 프로세싱
    if (navigator.userAgent.indexOf("becon_ios") !== -1) {
      action = JSON.parse(decodedParam).action;
      data = JSON.stringify(JSON.parse(decodedParam).data);
    }
    console.group("onResultAction data");

    console.log(navigator.userAgent.indexOf("becon_ios"), "isIos");
    console.log(action, "action");

    console.groupEnd();

    // * 두피 사진 촬영 (원격진료)
    if (action === "MTakeTelemedicinePhoto") {
      console.log("last test : rawData >>>", data);
    }

    // * 소셜 로그인 (카카오)
    if (action === actionNames.loginAccount) {
      const kakaoUserData = JSON.parse(data);
      setAxiosAccessToken(axiosInstance, kakaoUserData.access_token);
      store.set(localStorageKeyToken, {
        refreshToken: kakaoUserData.refresh_token,
        accessToken: kakaoUserData.access_token,
      });
      // eslint-disable-next-line no-restricted-globals
      location.reload();

      return;
    }

    // * 앱정보
    if (action === actionNames.getAppInfo || action === actionNames.appInfo) {
      setAppVersion(JSON.parse(data).current_version);
      // dispatch(setAppVersion(JSON.parse(data).current_version));
      return;
    }

    // * FCM 토큰 정보 (앱 푸시기능을 위한 FCM 토큰)
    if (action === actionNames.fcmTokenInfo) {
      dispatch(setFcmToken(JSON.parse(data).fcmToken));
    }

    // * 앱 알림 on/off (true/false)
    if (action === actionNames.notificationInfo) {
      dispatch(setNotification(JSON.parse(data).isAllowNotification));
    }

    // * 기기 정보
    if (action === actionNames.deviceInfo) {
      const deviceInfo = JSON.parse(data);
      console.log(deviceInfo);
      console.log(JSON.stringify(deviceInfo));
      setScannerStateInfo(deviceInfo);
      dispatch(setDeviceInfo(deviceInfo));
      return;
    }

    // * 앱 사용자설정 언어
    if (action === actionNames.getLanguage || action === actionNames.language) {
      if (JSON.parse(data).language === "ko" || JSON.parse(data).language === "kr") {
        i18n.changeLanguage("ko");
        dispatch(setLanguage("ko"));
      } else if (JSON.parse(data).language === "ja") {
        i18n.changeLanguage("ja");
        dispatch(setLanguage("ja"));
      } else if (JSON.parse(data).language === "vi") {
        i18n.changeLanguage("vi");
        dispatch(setLanguage("vi"));
      } else if (JSON.parse(data).language === "es") {
        i18n.changeLanguage("es");
        dispatch(setLanguage("es"));
      } else {
        i18n.changeLanguage("en");
        dispatch(setLanguage("en"));
      }
    }
  };
}

export default useOnResultAction;
